import React from "react";
import "./index.css";
import { render } from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
//react-redux-libraries
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
//
import rootReducer from "./reduxStore/reducers/combineReducer";
import { BrowserRouter } from "react-router-dom";

import { composeWithDevTools } from "redux-devtools-extension";
import AllRoutes from "./components/AllRoutes/AllRoutes";

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

render(
  <Provider store={store}>
    <BrowserRouter>
      <AllRoutes />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
